import styled, { css } from 'styled-components';

export const StatusText = styled.p`
  font-size: 20px;
  font-weight: bold;

  ${({ color }) => css`
    color: ${color}
  `};
`;
